export const DATA_HOOKS = { ROOT: 'core-input-root' };
//# sourceMappingURL=dataKeys.js.map